<div
  *ngIf="businessDetails || comingSoon || demo"
  [ngStyle]="{ pointerEvents: disabled ? 'none' : 'all' }"
  class="box-wrap search-result-thumbnail"
>
  <!--   (click)="onTitleClick('playVideo')"-->
  <div
    (click)="!isMobile ? runVideo($event) : null"
    (touchstart)="runVideoMobile($event)"
    [ngClass]="{
      warning: demo && !businessDetails?.videoCoverImageThumbnailUrl
    }"
    [ngStyle]="{ pointerEvents: disabled ? 'none' : 'all' }"
    class="col-12 video-thumbnail sub-head"
  >
    <img
      #coverImage
      (load)="calcCover()"
      *ngIf="
        !comingSoon && !(!businessDetails?.videoCoverImageThumbnailUrl && demo)
      "
      [ngClass]="{ absolute: !disabled || pocket }"
      [ngStyle]="{ 'object-fit': isCoverLandscape ? 'cover' : 'contain' }"
      [src]="businessDetails?.videoCoverImageThumbnailUrl || videoThumbSrc"
      alt="videoThumbSrc"
      rel="preload"
    />
    <div
      *ngIf="comingSoon && !demo"
      class="coming-soon {{ businessDetails?.businessType }}"
    >
      PitchCard not available
    </div>
    <div
      *ngIf="!businessDetails?.videoCoverImageThumbnailUrl && demo"
      class="demo-placeholder absolute"
    >
      <img
        alt="photos-demo"
        src="assets/images/pitch-card-svg/photos-demo.svg"
      />
    </div>
    <!--    <video class="video {{businessDetails?.isMirrorVideo ? 'video-rotated' : ''}}" [ngStyle]="{'display': playVideo ? 'block' : 'none'}" disablePictureInPicture-->
    <!--      style="height:100%; width:100%" #videoPlayer (timeupdate)="onTimeUpdate($event)" preload="metadata" playsinline (canplay)='showPlayer()'-->
    <!--      [id]="'videoPlayer'+ index" webkit-playsinline="true"></video>-->
    <div
      *ngIf="initVideo"
      [ngClass]="{ 'opacity-0': !playVideo && isDesktop }"
      class="video"
    >
<!--      <app-video-js-player-->
<!--        #videoPlayer-->
<!--        (timeUpdate)="onTimeUpdate($event)"-->
<!--        (uploadError)="handleUploadVideoError()"-->
<!--        [allowFullScreenOnRotate]="false"-->
<!--        [autoplay]="true"-->
<!--        [businessId]="businessDetails?.id"-->
<!--        [isVideoMirrored]="businessDetails?.isMirrorVideo"-->
<!--        [muted]="mutedVideo"-->
<!--        [muxVideoId]="businessDetails.videoFileUrl"-->
<!--      >-->
<!--      </app-video-js-player>-->
    </div>
    <span
      *ngIf="!initVideo"
      class="sprite big-video-svg {{ businessDetails?.businessType }}"
    ></span>

    <span
      id="countdown-timer"
      *ngIf="videoDuration && countdownTimer"
      class="countdown-timer"
    >
      :{{ countdownTimer < 10 ? '0' + countdownTimer : countdownTimer }}
    </span>
  </div>

  <div
    *ngIf="
      (!!businessDetails?.businessLogoThumbnailUrl &&
        businessDetails?.businessType === PitchCardType.Basic) ||
      (!!businessDetails?.businessLogoThumbnailUrl &&
        businessDetails?.businessType === PitchCardType.Job)
    "
    [ngClass]="{
      'thumb-logo': businessDetails?.businessType !== PitchCardType.Job,
      'thumb-logo-job': businessDetails?.businessType === PitchCardType.Job
    }"
    class="col-12 text-center"
  >
    <img [src]="businessDetails?.businessLogoThumbnailUrl" alt="ThumbnailUrl" />
  </div>

  <div
    *ngIf="
      !businessDetails?.businessLogoThumbnailUrl &&
      (businessDetails?.businessType === PitchCardType.Basic ||
        businessDetails?.businessType === PitchCardType.Job)
    "
    [ngClass]="{
      'thumb-logo': businessDetails?.businessType !== PitchCardType.Job,
      'thumb-logo-job': businessDetails?.businessType === PitchCardType.Job,
      warning: demo
    }"
    [ngStyle]="{ visibility: comingSoon ? 'hidden' : '' }"
    class="col-12 text-center {{ businessDetails?.businessType }}"
  >
    <h2>Your logo</h2>
  </div>

  <div
    #cardBusinessName
    *ngIf="
      businessDetails?.businessType === PitchCardType.Basic ||
      businessDetails?.businessType === PitchCardType.Job
    "
    [ngStyle]="{ visibility: comingSoon ? 'hidden' : '' }"
    class="col-12 cards-names-wrapper {{ businessDetails?.businessType }}"
  >
    <span
      *ngIf="businessDetails?.businessType !== PitchCardType.Job"
      class="business-title text-ellipsis w-12"
    >
      <span [ngClass]="{ warning: demo && !businessDetails?.businessName }">
        {{ businessDetails?.businessName || 'Business Name' }}
      </span>
    </span>
    <span
      *ngIf="
        !businessDetails?.isHideTitle &&
        businessDetails?.businessType !== PitchCardType.Job
      "
      [class]="
        businessDetails?.title && !businessDetails?.isHideTitle
          ? 'business-name'
          : 'business-title'
      "
      [ngClass]="{
        warning:
          demo &&
          !businessDetails?.title &&
          businessDetails?.businessType !== PitchCardType.Basic
      }"
      class="text-ellipsis w-12"
    >
      {{
        businessDetails?.title
          ? businessDetails?.title
          : demo
            ? 'Your Name'
            : ''
      }}
    </span>

    <span
      *ngIf="businessDetails?.businessType === PitchCardType.Job"
      [ngClass]="{ warning: demo && !businessDetails?.businessName }"
      class="business-name text-ellipsis w-12"
    >
      {{ businessDetails?.businessName || 'Organization' }}
    </span>
  </div>

  <div
    *ngIf="
      businessDetails?.businessType === 'service' ||
      businessDetails?.businessType === 'nonprofit' ||
      businessDetails?.businessType === PitchCardType.Employee
    "
    [ngStyle]="{ visibility: comingSoon ? 'hidden' : '' }"
    class="service-card-info"
  >
    <div class="logo-block">
      <div
        *ngIf="!!businessDetails?.businessLogoThumbnailUrl"
        class="col-12 text-center thumb-logo"
      >
        <img [src]="businessDetails?.businessLogoThumbnailUrl" alt="" />
      </div>
      <div
        *ngIf="!businessDetails?.businessLogoThumbnailUrl"
        [ngClass]="{ warning: demo }"
        class="col-12 text-center thumb-logo {{
          businessDetails?.businessType
        }}"
      >
        <h2>Your logo</h2>
      </div>
    </div>
    <div
      *ngIf="businessDetails?.businessType !== PitchCardType.Job"
      [ngClass]="{ biggerText: biggerText }"
      class="person-info-block"
    >
      <span
        *ngIf="businessDetails?.businessType === PitchCardType.Service"
        [ngClass]="{
          warning: demo && !businessDetails?.businessName,
          'inline-flex': nameTwo
        }"
        class="business-name text-ellipsis w-12"
      >
        <span
          [ngClass]="{ 'text-ellipsis': nameTwo }"
          [ngStyle]="{ width: nameTwo ? '50%' : '100%' }"
        >
          {{ nameOne ? nameOne : 'Name' }}
        </span>
        <span
          *ngIf="nameTwo"
          class="w-6 text-center border-left-1 text-ellipsis"
        >{{ nameTwo }}</span
        >
      </span>
      <span
        *ngIf="businessDetails?.businessType === PitchCardType.Employee"
        [ngClass]="{ warning: demo && !businessDetails?.title }"
        class="business-name text-ellipsis w-12"
      >
        <span>{{ businessDetails?.title || 'Your Name' }}</span>
      </span>
      <span
        *ngIf="
          !businessDetails?.isHideTitle &&
          businessDetails?.businessType === PitchCardType.Service
        "
        class="title text-center text-ellipsis w-12"
      >{{
          businessDetails?.title ? businessDetails?.title : demo ? 'Title' : ''
        }}</span
      >
      <span
        *ngIf="
          !businessDetails?.isHideTitle &&
          businessDetails?.businessType === PitchCardType.Employee
        "
        [ngClass]="{ warning: demo && !businessDetails?.businessName }"
        class="title text-center text-ellipsis w-12"
      >{{
          businessDetails?.businessName
            ? businessDetails?.businessName
            : demo
              ? 'Business Title'
              : ''
        }}</span
      >
    </div>
  </div>

  <div
    *ngIf="businessDetails?.businessType === PitchCardType.Resume"
    [ngClass]="{ firefoxBlur: blur }"
    [ngStyle]="{
      visibility: comingSoon ? 'hidden' : '',
      display:
        (businessDetails?.businessType !== PitchCardType.Resume &&
          businessDetails?.businessType === 'service') ||
        businessDetails?.businessType === 'nonprofit'
          ? 'none'
          : ''
    }"
    class="resume-card-info"
  >
    <div class="resume-block">
      <div
        (click)="
          demo && !businessDetails?.resumeFileUrl
            ? null
            : onTitleClick('resumeFileDialog')
        "
        [ngClass]="{
          warning: demo && !businessDetails?.resumeFileUrl,
          unavailable: !businessDetails?.resumeFileUrl && !demo
        }"
        class="resume-btn"
      >
        <img
          *ngIf="demo && !businessDetails?.resumeFileUrl"
          alt="pricing-demo"
          class="gs-icon {{ businessDetails?.businessType }}"
          src="assets/images/pitch-card-svg/resume/pricing-demo.svg"
        />
        <img
          *ngIf="(demo && businessDetails?.resumeFileUrl) || !demo"
          [src]="
            !businessDetails?.resumeFileUrl && !demo
              ? 'assets/images/pitch-card-svg/resume/unavailable-resume.svg'
              : 'assets/images/pitch-card-svg/resume/pricing-icon.svg'
          "
          alt="pricing-demo"
          class="gs-icon {{ businessDetails?.businessType }}"
        />

        <span
          [ngClass]="{
            warning: demo && !businessDetails?.resumeFileUrl
          }"
          class="white-space-nowrap"
        >
          {{
            !demo && !businessDetails?.resumeFileUrl
              ? 'Resume Unavailable'
              : 'resume'
          }}
        </span>
      </div>
    </div>
    <div class="person-info-block">
      <span
        [ngClass]="{ warning: demo && !businessDetails?.businessName }"
        class="business-name text-ellipsis text-center w-12"
      >
        <span>{{
            nameOne || businessDetails?.businessName || 'Full Name'
          }}</span>
        <span *ngIf="nameTwo">|</span>
        <span *ngIf="nameTwo">{{ nameTwo }}</span>
      </span>
    </div>
  </div>

  <div
    (click)="onTitleClick('jobDetailsDialog')"
    *ngIf="businessDetails?.businessType === PitchCardType.Job"
    [ngStyle]="{
      visibility: comingSoon ? 'hidden' : '',
      display: businessDetails?.businessType !== PitchCardType.Job ? 'none' : ''
    }"
    class="job-card-info pointer"
  >
    <div class="job-block grid align-items-baseline no-margins">
      <div
        *ngIf="businessDetails?.positions"
        [pTooltip]="businessDetails?.positions[0]?.name"
        [tooltipDisabled]="businessDetails?.positions[0]?.name?.length < 20"
        [tooltipPosition]="'top'"
        class="position text-ellipsis no-padding"
        style="padding: 0 3px"
      >
        <span [ngClass]="{ warning: demo && !businessDetails?.positions }">
          {{
            businessDetails.positions[0]?.name
              ? businessDetails.positions[0]?.name
              : businessDetails.positions[0] || 'Position'
          }}
        </span>
      </div>
    </div>

    <div class="job-block grid align-items-baseline no-margins">
      <div class="key text-right no-padding">Type</div>

      <div class="value no-padding text-ellipsis">
        <span *ngIf="workTypeList">
          <span>{{ workTypeList }}</span>
        </span>
        <span
          *ngIf="!businessDetails?.workTypes?.length"
          [ngClass]="{ warning: demo && !businessDetails?.workTypes }"
        >Full-Time</span
        >
      </div>
    </div>

    <div class="job-block grid align-items-baseline no-margins">
      <div class="key text-right no-padding">Compensation</div>

      <div
        [pTooltip]="compensationDescription ? compensationDescription : ''"
        [tooltipDisabled]="
          !compensationDescription || compensationDescription.length <= 32
        "
        [tooltipPosition]="'top'"
        class="value no-padding text-ellipsis"
      >
        <span [ngClass]="{ warning: demo && !compensationDescription }">
          {{ compensationDescription || '' }}
        </span>
      </div>
    </div>

    <div class="job-block grid align-items-baseline no-margins">
      <div class="key text-right no-padding">Location</div>

      <div class="value no-padding text-ellipsis">
        <span
          *ngIf="!businessDetails?.isRemote"
          [ngClass]="{ warning: demo && !locationAddress }"
        >
          {{ locationAddress || 'txt_default_job_location' | translate }}
        </span>

        <span *ngIf="businessDetails?.isRemote" translate
        >txt_position_remote</span
        >
      </div>
    </div>

    <div class="job-block-info">
      <img
        alt="job-more-info"
        src="assets/images/pitch-card-svg/job/more-info.svg"
      />
    </div>
  </div>

  <div
    *ngIf="businessDetails?.businessType !== PitchCardType.Job"
    [ngClass]="{
      resumeMargin:
        businessDetails?.businessType === PitchCardType.Resume ||
        businessDetails?.businessType === PitchCardType.Service ||
        businessDetails?.businessType === PitchCardType.Basic ||
        businessDetails?.businessType === PitchCardType.Employee,
      firefoxBlur: blur
    }"
    class="col-12 review-wrap no-padding"
  >
    <div
      (click)="onTitleClick('watchVideoRevews')"
      [ngStyle]="{
        pointerEvents: !disabled || withVideoTestimonial ? 'all' : 'none'
      }"
      class="video-review {{ businessDetails?.businessType }}"
      style="cursor: pointer"
    >
      <div
        class="col-12 p-0 text-center head {{
          businessDetails?.businessType
        }} width-full"
        translate
      >
        <img
          *ngIf="
            businessDetails?.businessType === PitchCardType.Basic ||
            businessDetails?.businessType === PitchCardType.Employee
          "
          alt="play-solid"
          class="card-icon"
          src="/assets/images/pitch-card-svg/play-solid.svg"
        />
        <img
          *ngIf="businessDetails?.businessType === PitchCardType.Resume"
          alt="play-solid"
          class="card-icon"
          src="/assets/images/pitch-card-svg/resume/play-solid.svg"
        />
        <img
          *ngIf="
            businessDetails?.businessType === PitchCardType.Service ||
            businessDetails?.businessType === 'nonprofit'
          "
          alt="play-solid"
          class="card-icon"
          src="/assets/images/pitch-card-svg/service/play-solid.svg"
        />
        <span
        >video
          {{
            businessDetails?.businessType === PitchCardType.Resume
              ? 'references'
              : 'testimonials'
          }}</span
        >
      </div>
    </div>
  </div>

  <div
    #contacts
    [ngClass]="{ firefoxBlur: blur }"
    class="col-12 text-center no-padding"
  >
    <div
      class="contact-menu-container"
      [class.show]="isContactMenuOpen"
      #contactMenuParent
    >
      <div class="contact-menu">
        <ng-template #contactMenu>
          <ul>
            <li *ngIf="businessDetails?.contactNumber">
              <div>
                <img
                  alt="call-outline"
                  class="contact-menu-icon"
                  src="/assets/images/pitch-card-svg/call-outline.svg"
                />
              </div>
              <a (click)="addCallsAnalytics()">
                <span class="cm-title">Call</span><br />
                <span class="cm-value">{{
                    businessDetails?.contactNumber
                      | phone: businessDetails?.contactNumber
                  }}</span>
              </a>
            </li>
            <li *ngIf="businessDetails?.email">
              <div>
                <img
                  alt="email-outline"
                  class="contact-menu-icon"
                  src="/assets/images/pitch-card-svg/email-outline.svg"
                />
              </div>
              <a (click)="addEmailAnalytics()" class="text-ellipsis relative">
                <span class="cm-title">Email</span><br />
                <span class="cm-value" style="padding-left: 5px">{{
                    businessDetails?.email
                  }}</span>
              </a>
            </li>
            <li
              *ngIf="
                businessDetails?.address &&
                businessDetails?.city !== AppSettings.DEFAULT_CITY_ID &&
                businessDetails?.state !== AppSettings.DEFAULT_STATE_ID
              "
            >
              <div>
                <img
                  alt="direction-pin"
                  class="contact-menu-icon"
                  src="/assets/images/pitch-card-svg/directionpin-outline.svg"
                />
              </div>
              <a
                (click)="addLocationAnalytics()"
                [attr.href]="googleMapLink"
                target="_blank"
              >
                <span class="cm-title">Directions</span><br />
                <span class="cm-value">{{ formattedAddress }}</span>
              </a>
            </li>
            <li (click)="onTitleClick('contact')">
              <div>
                <img
                  alt="referral-outline"
                  class="contact-menu-icon"
                  src="/assets/images/pitch-card-svg/referral-outline.svg"
                />
              </div>
              <div>
                <span class="cm-title">Contact Me</span><br />
                <span class="cm-value"
                >Request contact from
                  {{
                    businessDetails?.businessType === PitchCardType.Resume
                      ? 'this person'
                      : businessDetails?.businessType === PitchCardType.Service
                        ? 'nonprofit'
                        : 'company'
                  }}
                </span>
              </div>
            </li>
            <li *ngIf="businessDetails?.calendarLink">
              <div>
                <img
                  class="contact-menu-icon"
                  src="/assets/images/pitch-card-svg/schedule-outline.svg"
                />
              </div>
              <div (click)="showCalendar(businessDetails?.calendarLink)">
                <span class="cm-title">Schedule</span><br />
                <span class="cm-value">Set up an appointment</span>
              </div>
            </li>
            <li
              (click)="onTitleClick('leaveareview')"
              *ngIf="businessDetails?.videoReviewCount === 0"
              class="cm-title-video-review"
            >
              <div>
                <img
                  alt="review-outline"
                  class="contact-menu-icon"
                  src="/assets/images/pitch-card-svg/review-outline.svg"
                />
              </div>
              <div>
                <span class="cm-title full-width"
                >Leave a Video Testimonial</span
                >
              </div>
            </li>
          </ul>
        </ng-template>

        <ng-template [ngTemplateOutlet]="contactMenu"></ng-template>
      </div>
    </div>
    <div
      (click)="!isMobile ? toggleContactMenu($event) : openBottomContactMenu()"
      *ngIf="businessDetails?.businessType !== PitchCardType.Job"
      [ngStyle]="{
        pointerEvents: !disabled || withShare ? 'all' : 'none'
      }"
      class="sec-btn gradient-button {{
        businessDetails?.businessType
      }} btn-shadow contact-menu-button"
      translate
    >
      label_contact
    </div>
    <div
      (click)="
        onTitleClick(
          businessDetails?.showRequirements
            ? 'showJobRequirementsDialog'
            : 'applyJobNowDialog'
        )
      "
      *ngIf="businessDetails?.businessType === PitchCardType.Job"
      [ngStyle]="{
        pointerEvents: !disabled || withContact ? 'all' : 'none'
      }"
      class="sec-btn gradient-button {{
        businessDetails?.businessType
      }} btn-shadow contact-menu-button"
      translate
    >
      label_apply_now
    </div>

    <div class="contact-menu-container" [class.show]="isContactMenuOpen">
      <div class="contact-menu">
        <ng-template [ngTemplateOutlet]="contactMenu"></ng-template>
      </div>
    </div>
  </div>

  <div [ngClass]="{ firefoxBlur: blur }" class="grid-share-container">
    <div
      (click)="
        !isMobile
          ? toggleContactMenu($event, contacts)
          : openBottomContactMenu()
      "
      *ngIf="businessDetails?.businessType === PitchCardType.Job"
      [ngStyle]="{
        pointerEvents: !disabled || withShare ? 'all' : 'none'
      }"
      class="gs-pricing {{
        businessDetails?.businessType
      }} flex-vertical contact-menu-button"
      translate
    >
      <div class="icon-wrap">
        <img
          alt="contact-outline"
          class="gs-icon {{ businessDetails?.businessType }}"
          src="assets/images/pitch-card-svg/job/contact-outline.svg"
        />
      </div>
      label_contact
    </div>

    <div
      (click)="onTitleClick('companyImgDialog')"
      *ngIf="this.businessDetails?.businessType !== PitchCardType.Job"
      [ngStyle]="{
        pointerEvents: !disabled || withAttachment ? 'all' : 'none'
      }"
      class="gs-pricing {{ businessDetails?.businessType }} flex-vertical"
      translate
    >
      <div
        *ngIf="
          demo &&
          !businessDetails?.employeePictureFileIds &&
          businessDetails?.businessType
        "
        class="icon-wrap"
      >
        <img
          [src]="
            'assets/images/pitch-card-svg/' +
            (businessDetails?.businessType === PitchCardType.Basic ||
            businessDetails?.businessType === PitchCardType.Employee
              ? ''
              : businessDetails?.businessType) +
            '/attachments.svg'
          "
          alt="photos-demo"
          class="gs-icon {{ businessDetails?.businessType }}"
        />
      </div>

      <div
        *ngIf="
          (businessDetails?.employeePictureFileIds || !demo) &&
          (businessDetails?.businessType === PitchCardType.Basic ||
            businessDetails?.businessType === PitchCardType.Employee)
        "
        class="icon-wrap"
      >
        <img
          alt="photos-outline"
          class="gs-icon {{ businessDetails?.businessType }}"
          src="assets/images/pitch-card-svg/attachments.svg"
        />
      </div>

      <div
        *ngIf="
          ((demo && businessDetails?.employeePictureFileIds) || !demo) &&
          businessDetails?.businessType === PitchCardType.Resume
        "
        class="icon-wrap"
      >
        <img
          alt="photos-outline"
          class="gs-icon {{ businessDetails?.businessType }}"
          src="assets/images/pitch-card-svg/resume/attachments.svg"
        />
      </div>

      <div
        *ngIf="
          (((demo && businessDetails?.employeePictureFileIds) || !demo) &&
            businessDetails?.businessType === PitchCardType.Service) ||
          businessDetails?.businessType === 'nonprofit'
        "
        class="icon-wrap"
      >
        <img
          alt="photos-outline"
          class="gs-icon {{ businessDetails?.businessType }}"
          src="assets/images/pitch-card-svg/service/attachments.svg"
        />
      </div>
      label_company_images
    </div>

    <div
      (click)="
        onTitleClick(
          this.businessDetails?.businessType === PitchCardType.Job
            ? 'watchVideoRevews'
            : 'moreInfoDialog'
        )
      "
      [ngStyle]="{ pointerEvents: !disabled || withMoreInfo ? 'all' : 'none' }"
      class="gs-photos {{ businessDetails?.businessType }} flex-vertical"
      translate
    >
      <div
        *ngIf="
          businessDetails?.businessType === PitchCardType.Basic ||
          businessDetails?.businessType === PitchCardType.Employee
        "
        class="icon-wrap"
      >
        <img
          alt="more-info"
          class="gs-icon {{ businessDetails?.businessType }}"
          src="assets/images/pitch-card-svg/more-info.svg"
        />
      </div>

      <div
        *ngIf="businessDetails?.businessType === PitchCardType.Resume"
        class="icon-wrap"
      >
        <img
          alt="more-info"
          class="gs-icon {{ businessDetails?.businessType }}"
          src="assets/images/pitch-card-svg/resume/more-info.svg"
        />
      </div>

      <div
        *ngIf="
          businessDetails?.businessType === 'service' ||
          businessDetails?.businessType === 'nonprofit'
        "
        class="icon-wrap"
      >
        <img
          alt="more-info"
          class="gs-icon {{ businessDetails?.businessType }}"
          src="assets/images/pitch-card-svg/service/more-info.svg"
        />
      </div>

      <div
        *ngIf="this.businessDetails?.businessType === PitchCardType.Job"
        class="icon-wrap"
      >
        <img
          alt="employer-reviews"
          class="gs-icon {{ businessDetails?.businessType }}"
          src="assets/images/pitch-card-svg/job/employer-reviews.svg"
        />
      </div>

      <span>{{
          this.businessDetails?.businessType === PitchCardType.Job
            ? 'TESTIMONIALS'
            : 'more info'
        }}</span>
    </div>

    <div
      (click)="toggleAsFavorite()"
      [ngStyle]="{
        pointerEvents: !disabled || withSave ? 'all' : 'none'
      }"
      class="share-button {{ businessDetails?.businessType }} btn-shadow "
    >
      <span *ngIf="!businessDetails?.isFavoriteBusiness" translate>
        label_save_As_favorite</span
      >
      <span *ngIf="businessDetails?.isFavoriteBusiness" translate
      >label_remove_As_favorite</span
      >
      <a
        [download]="
          vCard?.name?.firstNames ? vCard.name.firstNames + '.vcf' : 'vCard.vcf'
        "
        [href]="vCardUrl"
        class="grid justify-content-start p-0 m-0 contracts-vcf"
        style="visibility: hidden"
      ></a>
    </div>

    <div
      (click)="onTitleClick('share')"
      *ngIf="isAllCompleted; else notCompleted"
      [ngStyle]="{
        pointerEvents: !disabled || withContact ? 'all' : 'none'
      }"
      class="share-button {{ businessDetails?.businessType }} btn-shadow "
      translate
    >
      label_share
    </div>
    <ng-template #notCompleted>
      <div
        [ngStyle]="{
          backgroundImage: 'linear-gradient(#C4C4C4, #C4C4C4)',
          boxShadow: 'none'
        }"
        class="share-button {{ businessDetails?.businessType }} btn-shadow "
        translate
      >
        label_share
      </div>
    </ng-template>
  </div>
  <app-ep-restrict
    (submitClick)="onTitleClick('contactMe')"
    [isShowBlur]="blur"
    [isShowRestrict]="isShowRestrict"
    [scale]="scale"
  ></app-ep-restrict>
</div>

<div *ngIf="isMobile" class="bottom-sidebar">
  <app-sidebar
    [(visible)]="isMobileContactMenuOpen"
    [appendTo]="'body'"
    [baseZIndex]="10"
    [dismissible]="true"
    [position]="'bottom'"
    [showCloseIcon]="false"
    [style]="{
      height: 'auto',
      borderRadius: '.5em',
      background: 'transparent'
    }"
  >
    <div class="mob-contact-menu">
      <ul>
        <li
          *ngIf="businessDetails?.contactNumber"
          class="grid justify-content-start flex-nowrap"
        >
          <div class="col-1 contact-icon">
            <img
              alt="Phone"
              src="assets/images/contact-menu-svg/phoneicon.svg"
            />
          </div>

          <div class="col-10 text-center">
            <div class="font-medium text-xl">Call</div>
            <a (click)="addCallsAnalytics()">
              <span class="text-base link">
                {{
                  businessDetails?.contactNumber
                    | phone: businessDetails?.contactNumber
                }}
              </span>
            </a>
          </div>
        </li>

        <li *ngIf="businessDetails?.email" class="grid justify-content-start">
          <div class="col-1 contact-icon">
            <img
              alt="Email"
              src="assets/images/contact-menu-svg/emailicon.svg"
            />
          </div>

          <div class="col-10 text-center">
            <div class="font-medium text-xl">Email</div>
            <a (click)="addEmailAnalytics()">
              <span class="contact-icon-title">
                {{ businessDetails?.email }}
              </span>
            </a>
          </div>
        </li>

        <li
          *ngIf="
            businessDetails?.address &&
            businessDetails?.city !== AppSettings.DEFAULT_CITY_ID &&
            businessDetails?.state !== AppSettings.DEFAULT_STATE_ID
          "
          class="grid justify-content-start"
        >
          <div class="col-1 contact-icon">
            <img
              alt="Location"
              src="assets/images/contact-menu-svg/directions.svg"
            />
          </div>

          <div class="col-10 text-center">
            <div class="font-medium text-xl">Location</div>
            <a
              (click)="addLocationAnalytics()"
              [attr.href]="googleMapLink"
              target="_blank"
            >
              <span class="contact-icon-title">
                {{ formattedAddress }}
              </span>
            </a>
          </div>
        </li>

        <li
          (click)="isMobileContactMenuOpen = false; onTitleClick('contact')"
          class="grid justify-content-start"
        >
          <div class="col-1 contact-icon">
            <img
              alt="Callback"
              src="assets/images/contact-menu-svg/callbacks.svg"
            />
          </div>

          <div class="col-10 text-center">
            <span class="font-medium text-xl">Contact Me</span><br />
          </div>
        </li>

        <li
          *ngIf="businessDetails?.calendarLink"
          class="grid justify-content-start"
        >
          <div class="col-1 contact-icon">
            <img
              alt="Schedule"
              src="assets/images/contact-menu-svg/scheduleicon.svg"
            />
          </div>

          <div
            (click)="showCalendar(businessDetails?.calendarLink)"
            class="col-10 text-center"
          >
            <span class="font-medium text-xl">Schedule</span><br />
          </div>
        </li>

        <li
          id="downloadButtonNormal"
          (click)="onTitleClick('addToContact')"
          *ngIf="
            vCard &&
            isMobile &&
            businessDetails?.businessType !== PitchCardType.Job
          "
        >
          <a
            [download]="
              vCard?.name?.firstNames
                ? vCard.name.firstNames + '.vcf'
                : 'vCard.vcf'
            "
            [href]="vCardUrl"
            class="grid justify-content-start p-0 m-0"
          >
            <div class="col-1 contact-icon">
              <img
                alt="Add to contact"
                src="assets/images/contact-menu-svg/add-contact.svg"
              />
            </div>

            <div class="col-10 text-center">
              <span class="font-medium text-xl"> Add to Contacts </span>
            </div>
          </a>
        </li>

        <li
          (click)="
            onTitleClick('leaveareview'); isMobileContactMenuOpen = false
          "
          *ngIf="businessDetails?.videoReviewCount === 0"
          class="cm-title-video-review grid justify-content-start"
        >
          <div class="col-1 contact-icon">
            <img
              alt="Upload"
              src="assets/images/contact-menu-svg/uploadicon.svg"
            />
          </div>

          <div class="col-10 text-center">
            <span class="font-medium text-xl"> Leave a Video Testimonial </span>
          </div>
        </li>

        <li
          (click)="isMobileContactMenuOpen = false"
          class="grid justify-content-center bg-white mt-2 mb-3"
        >
          <div class="col-12 text-center">
            <span class="font-medium text-xl">Cancel</span>
          </div>
        </li>
      </ul>
    </div>
  </app-sidebar>
</div>
